import { cssVar } from '../css/css-var';
import { theme } from '../theme';

export const typographyVariant = {
  // font-height is intentionally removed, ui is not consistent at all and to avoid overriding for every usage
  h1: {
    fontSize: 2.4,
    fontWeight: 'bold',
    fontFamily: cssVar(theme.fonts.secondary),
  },
  h2: {
    fontSize: 2.2,
    fontWeight: 'bold',
    fontFamily: cssVar(theme.fonts.secondary),
  },
  h3: {
    fontSize: 2,
    fontWeight: 'bold',
    fontFamily: cssVar(theme.fonts.primary),
  },
  h4: {
    fontSize: 1.8,
    fontWeight: 'bold',
    fontFamily: cssVar(theme.fonts.primary),
  },
  h5: {
    fontSize: 1.6,
    fontWeight: 'bold',
    fontFamily: cssVar(theme.fonts.primary),
  },
  h6: {
    fontSize: 1.4,
    fontWeight: 'bold',
    fontFamily: cssVar(theme.fonts.primary),
  },
  'callout-bold': {
    fontSize: 1.3,
    fontWeight: 'bold',
    fontFamily: cssVar(theme.fonts.primary),
  },
  'subhead-bold': {
    fontSize: 1.2,
    fontWeight: 'bold',
    fontFamily: cssVar(theme.fonts.primary),
  },
  body: {
    fontSize: 1.4,
    fontWeight: 'normal',
    fontFamily: cssVar(theme.fonts.primary),
  },
  callout: {
    fontSize: 1.3,
    fontWeight: 'normal',
    fontFamily: cssVar(theme.fonts.primary),
  },
  subhead: {
    fontSize: 1.2,
    fontWeight: 'normal',
    fontFamily: cssVar(theme.fonts.primary),
  },
};
